<script setup lang="ts">
import { MixpanelProps } from '~/core/service/mixpanel';
import type { RegionQuestionsProps } from '.';
import ContentBlock from '@/components/ContentBlock/ContentBlock.vue';
import { useEvents } from '~/composables/events/useEvents';

const props = withDefaults(defineProps<RegionQuestionsProps>(), {
	contentBlockVariant: 'white-dark-3'
});

const title = computed<string>(() =>
	props.title?.trim()
		? props.title?.trim()
		: `Dúvidas frequentes sobre ${props.name}`
);

const { trackFaqClicked } = useEvents();
const route = useRoute();

const handleFaqClick = (question: string, position: number) => {
	if (question) {
		trackFaqClicked({
			[MixpanelProps.QUESTION_TEXT]: question,
			[MixpanelProps.CURRENT_PAGE]: String(route.fullPath),
			[MixpanelProps.CURRENT_NEIGHBORHOD]: props.name,
			[MixpanelProps.QUESTION_POSITION]: position
		});
	}
};
</script>

<template>
	<ContentBlock
		:variant="contentBlockVariant"
		:title="title"
		title-as="h2"
		content-class="space-y-6 p-0 md:p-0 lg:p-0 max-w-[940px] mx-auto"
		title-class="max-w-[940px] mx-auto"
	>
		<QuestionsAccordion
			:questions="questions"
			:accordion-trigger-as="accordionTriggerAs"
			@question-clicked="e => handleFaqClick(e.question, e.position)"
		/>
	</ContentBlock>
</template>
